export default __webpack_public_path__ + "static/media/chuoi-chien.9470b43c.jpg";